import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../button/button.component';
import { Store } from '@ngrx/store';
import { EquipmentState } from '../../../store/equipment/equipment.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-chat-form',
  standalone: true,
  imports: [MatChipsModule, CommonModule, MatInputModule, MatFormFieldModule, FormsModule, MatIconModule, ButtonComponent],
  templateUrl: './chat-form.component.html',
  styleUrl: './chat-form.component.css'
})
export class ChatFormComponent implements OnInit {
  maxPrompts = environment.maxPrompts;
  public prompts: string[] = [];
  public isSeeMore: boolean = false;
 
  @Input() isLoading: boolean = false;
  @Input() error: boolean = false;
  
  public message: string = '';

  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();
  
  constructor(private store: Store<{ equipment: EquipmentState }>) {}

  ngOnInit(): void {
    this.isLoading = false;
    this.store.select(state => state.equipment.equipment.prompts).subscribe(prompts => {
       this.prompts = prompts || [];
    });
  }
get filteredPrompts(): string[] {
  return (this.prompts || []).filter(
    p => p && p.toString().toLowerCase() !== 'nan'
  );
}

  seeMore(): void {
    this.isSeeMore = !this.isSeeMore;
  }

  selectPrompt(prompt: string): void {
    this.message = prompt;
  }

  handleClick(): void {
    this.isLoading = true;
    this.onSubmit.emit(this.message);
  }

onEnterKey(event: KeyboardEvent): void {
  if (!event.shiftKey && this.message && !this.isLoading) {
    event.preventDefault();
    this.handleClick();
  }
}

}
